export default __webpack_public_path__ + "static/img_history-bbc7a0ebe025eeb8a8e7b600716e1a6b.jpg";